import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { CtaButton } from "@/components/site/CtaButton";

export const PickCard = ({ slug, no, name, tag, blurb, img, bg, glow, accent, variant, path, cover, panel }) => (
  <Reveal className="h-full">
    <article data-testid={`pick-card-${slug}`}
      className="group relative flex h-full flex-col overflow-hidden rounded-[2.25rem] border border-[#F2EDE4]/10 p-6 sm:p-8" style={{ background: bg }}>
      <div className="flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-[0.25em]" style={{ color: accent }}>{tag}</span>
        <span className="font-mono text-xs text-[#F2EDE4]/55">No. {no}</span>
      </div>
      <div className={`relative my-8 grid aspect-[4/3] place-items-center ${cover || panel ? "overflow-hidden rounded-[1.5rem]" : ""} ${panel ? "bg-white" : ""}`}>
        <div className="absolute h-3/4 w-3/4 rounded-full blur-3xl transition-transform duration-700 group-hover:scale-110" style={{ background: glow }} />
        <img src={img} alt={name} className={`absolute inset-0 h-full w-full transition-transform duration-700 ${cover ? "object-cover group-hover:scale-105" : panel ? "object-contain p-4 group-hover:scale-105" : "object-contain drop-shadow-[0_30px_40px_rgba(0,0,0,0.5)] group-hover:-translate-y-2 group-hover:scale-[1.03]"}`} />
      </div>
      <h2 className="font-display text-3xl font-bold tracking-tight text-[#F2EDE4] sm:text-4xl">{name}</h2>
      <p className="mt-3 max-w-md text-base leading-relaxed text-[#F2EDE4]/75">{blurb}</p>
      <div className="mt-auto flex flex-wrap items-center gap-3 pt-8">
        <Link to={path} data-testid={`pick-read-${slug}`}
          className="inline-flex items-center gap-2 rounded-full border border-[#F2EDE4]/30 px-6 py-3.5 text-sm font-semibold text-[#F2EDE4] transition-colors hover:bg-[#F2EDE4] hover:text-[#091D18]">
          Read our review <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
        <CtaButton testId={`pick-buy-${slug}`} placement="home" product={slug} variant={variant}>Official site</CtaButton>
      </div>
    </article>
  </Reveal>
);
